import { useEffect, useState } from "react";

const CountDownTimer = ({ seconds, setIsView }) => {
    const [secs, setTime] = useState(seconds);

    const tick = () => {
        if (secs === 0) {
            setIsView(2)
        }
        setTime(secs - 1);
    };

    useEffect(() => {
        const timerId = setInterval(() => tick(), 1000);
        return () => clearInterval(timerId);
    });
    var min = Math.floor(secs / 60);
    var seconds = secs - min * 60;
    var format = (`0${min}:${seconds < 10 ? "0" + seconds : seconds}`);

    return format;
}

export default CountDownTimer;